module.exports = {
      id: "automobile-usage",
      viewBox: "0 0 31.664 23.083",
      url: "/" + "sprite-ab56b996b385d9abaaf31e01c38c81cd.svg#automobile",
      toString: function () {
        return this.url;
      }
    }